@if (hasNecessaryDataSetup$ | async) {
  <blaze-data-connector-details
    (showNext)="showDatasetsPage()"
    [connector]="connector"
    [hidden]="isHidden(DialogPage.Setup)"
    [template]="template"
    [initialFormValues]="initialFormValues"
  />
}

@if (hasNecessaryDataDatasets$ | async) {
  <blaze-data-connector-datasets
    (showPreview)="showPreviewPage($event)"
    (showPrevPage)="showPrevPage()"
    [connector]="connector"
    [template]="template"
    [linkedTableConnector]="linkedTableConnector"
    [hidden]="isHidden(DialogPage.Datasets)"
  />
}

@if (hasNecessaryDataPreviewDatasets$ | async) {
  <blaze-dataset-preview
    (showPrevPage)="showPrevPage()"
    [dataset]="previewDataset"
    [hidden]="isHidden(DialogPage.PreviewDataset)"
    [previewData]="previewData"
    (refreshDataset)="refreshDataset()"
  />
}

@if (hasNecessaryDataPreviewTable$ | async) {
  <blaze-dataset-preview
    (showPrevPage)="showPrevPage()"
    [dataset]="previewTable"
    [hidden]="isHidden(DialogPage.PreviewTable)"
    [previewData]="previewData"
    (refreshDataset)="refreshDataset()"
  />
}

@if (hasNecessaryDataBlazeTable$ | async) {
  <blaze-table-dialog
    (refreshDataset)="refreshTableData($event)"
    (showPrevPage)="showPrevPage()"
    [hidden]="isHidden(DialogPage.BlazeTable)"
  />
}

@if (hasNecessaryDataBlazeTableLink$ | async) {
  <blaze-linked-blaze-table-dialog
    (showNextPage)="showDatasetsPageForLinkedTable($event)"
    [hidden]="isHidden(DialogPage.LinkedBlazeTable)"
    [hideGroups]="[projectGroupId]"
  />
}

@if ((hasNecessaryDataSetup$ | async) && isOnPage(DialogPage.ConnectorWizard, 'Shopify')) {
  <blaze-shopify-connector-dialog
    [template]="template"
    [connectorCreationRequest]="connectorCreationRequest"
  />
}

@if ((hasNecessaryDataRestApi$ | async) && isOnPage(DialogPage.RestApi)) {
  <blaze-rest-api-connector-dialog
    [connector]="connector"
    [coupledConnector]="coupledConnector$ | async"
    (connectorUpdated)="saveRestApiConnector($event)"
    [hidden]="isHidden(DialogPage.RestApi)"
  />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Aircall')) {
  <blaze-aircall-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Airtable')) {
  <blaze-airtable-connector-dialog [template]="template" [connector]="connector" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Typeform')) {
  <blaze-typeform-connector-dialog [template]="template" [connector]="connector" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Calendly')) {
  <blaze-calendly-connector-dialog [template]="template" [connector]="connector" />
}

@if (isOnPage(DialogPage.ConnectorWizard) && isGenericOAuthConnector(connectorTarget)) {
  <blaze-generic-oauth-connector-dialog
    (showDatasets)="showDatasetsPageForConnector($event)"
    [config]="connectorOAuthConfig"
    [connector]="connector"
    [template]="template"
  />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'MicrosoftTeams')) {
  <blaze-microsoft-teams-connector-dialog [template]="template" [connector]="connector" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'OneDrive')) {
  <blaze-one-drive-connector-dialog
    (showDatasets)="showDatasetsPageForConnector($event)"
    [template]="template"
    [connector]="connector"
  />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'GoogleSheets')) {
  <blaze-google-sheets-connector-dialog
    (showDatasets)="showDatasetsPageForConnector($event)"
    [connector]="connector"
    [template]="template"
  />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'GoogleMail')) {
  <blaze-google-mail-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'GoogleAnalytics')) {
  <blaze-google-analytics-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'GoogleCalendar')) {
  <blaze-google-calendar-connector-dialog
    (showDatasets)="showDatasetsPageForConnector($event)"
    [connector]="connector"
    [template]="template"
  />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'InBody')) {
  <blaze-in-body-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Twilio')) {
  <blaze-twilio-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'LifeFile')) {
  <blaze-lifefile-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Dropbox')) {
  <blaze-dropbox-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'DropboxSign')) {
  <blaze-dropbox-sign-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Cal.com')) {
  <blaze-cal-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'OpenAI')) {
  <blaze-openai-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'PioneerRx')) {
  <blaze-pioneer-rx-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'ScriptSure')) {
  <blaze-scriptsure-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'Stripe')) {
  <blaze-stripe-connector-dialog [connector]="connector" [template]="template" />
}

@if (isOnPage(DialogPage.ConnectorWizard, 'MailGun')) {
  <blaze-mailgun-connector-dialog [connector]="connector" [template]="template" />
}

@if ((hasNecessaryDataCurrent$ | async) === false) {
  <blaze-panel>
    <span title>Loading Connector...</span>
    <div content>
      <blaze-element-loading-indicator [isVisible]="true" />
    </div>
  </blaze-panel>
}
